<template>
    <section id="sec4">
    <div :class="{'formulario': cor == false, 'formulariodark': cor == true}">
        <h1 v-if="traduzir == true">Preencha o Formulário e entraremos em contato!</h1>
        <h1 v-else>Fill out the form and we will contact you!</h1>

        <form @submit.prevent="criarFormulario($event)" :class="{'desaparece': envio == true}">
            <label for="nome" v-if="traduzir == true">Nome</label>
            <label for="nome" v-else>Name</label>
            <input type="text" v-if="traduzir == true" placeholder=" Nome" v-model="nome" id="nome" maxlength="255" required>
            <input type="text" v-else placeholder=" Name" v-model="nome" id="nome" maxlength="255" required>

            <label for="email">E-mail</label>
            <input type="email" placeholder=" E-mail" v-model="email" id="email" maxlength="255" required>

            <label for="telefone" v-if="traduzir == true">Telefone</label>
            <label for="telefone" v-else>Phone</label>
            <input type="tel" placeholder=" (XX) 9XXXX-XXXX" v-model="telefone" id="telefone" v-maska data-maska="['(##) ####-####', '(##) #####-####']" required>

            <label for="solucao" v-if="traduzir == true">Solução</label>
            <label for="solucao" v-else>Solution</label>
            <select name="solucao" id="solucao" v-model="solucao" required>
                <option value="null" v-if="traduzir == true" selected>Selecione uma opção</option>
                <option value="null" v-else selected>Select an option</option>
                <option value="aplicativo" v-if="traduzir == true">Aplicativo</option>
                <option value="aplicativo" v-else>App</option>
                <option value="site" v-if="traduzir == true">Site</option>
                <option value="site" v-else>Website</option>
                <option value="jogo" v-if="traduzir == true">Jogo</option>
                <option value="jogo" v-else>Game</option>
                <option value="aplicativo+site" v-if="traduzir == true">Aplicativo + Site</option>
                <option value="aplicativo+site" v-else>App + Website</option>
                <option value="completo" v-if="traduzir == true">Completo</option>
                <option value="completo" v-else>Complete</option>
            </select>

            <label for="detalhes" v-if="traduzir == true">Detalhes</label>
            <label for="detalhes" v-else>Details</label>
            <textarea name="detalhes" id="detalhes" v-if="traduzir == true" placeholder="  Digite os detalhes sobre oque deseja(opcional)" v-model="detalhes" maxlength="3000"></textarea>
            <textarea name="detalhes" id="detalhes" v-else placeholder="  Enter the details of what you want (optional)" v-model="detalhes" maxlength="3000"></textarea>

            <button v-if="traduzir == true">Enviar</button>
            <button v-else>Send</button>
        </form>

        <div :class="{'desaparece': envio == false, 'mensagem': envio == true}">
            <h2 v-if="traduzir == true">Formulário enviado com sucesso!</h2>
            <h2 v-else>Form submitted successfully!</h2>
        </div>
    </div>
    </section>
</template>

<script>
    import { vMaska } from 'maska/vue';

    export default { 
    name: 'Formulario',

    directives: { maska: vMaska },

    props: {
        cor: true,
        traduzir: true,
    },

    data(){
        return{
            nome: null,
            email: null,
            telefone: null,
            solucao: null,
            detalhes: null,
            envio: false
        }
    },

    methods: {
        async criarFormulario(evento){
            //console.log(evento);  
            evento.preventDefault(); 

            var valor = {
                nome: this.nome,
                email: this.email,
                telefone: this.telefone,
                solucao: this.solucao,
                detalhes: this.detalhes
            };
            //console.log(valor);

            const dataJson = JSON.stringify(valor); //converto esses dados para json

            //vou enviar os dados para o banco, no caso para a API
            const req = await fetch("/api/formulario", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: dataJson
            });

            const res = await req.json();
            //console.log(res); //estou mostrando o resultado da resposta da API no banco

            if(res.erro){
                console.log(res);
                alert("ERRO PARA ENVIAR FORMULÁRIO, ENTRE EM CONTATO POR E-MAIL OU WHATSAPP!");
            }

            this.envio = true;
        }
    }

}

</script>

<style src="./formulario.scss" lang="scss" scoped></style>